export const GET_FREE_HOURS_FOR_DATE = 'GET_FREE_HOURS_FOR_DATE';
export const GET_BUSY_DATES = 'GET_BUSY_DATES';
